import { enumSharedMsgs } from "../helpers/common.constants";
import { ValidatorHelper } from "../helpers/ValidatorHelper";
import { TaskService } from "../services/TaskService";

export default class TaskActions {


  async EditAsync(Record: any) {
    let response = await new TaskService().Edit(Record);

    let responses = [response];

    //napravi validacija
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async EditWithCheckAsync(Record: any) {
    let response = await new TaskService().EditWithCheck(Record);

    let responses = [response];

    //napravi validacija
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }



async ValidateAsync(Record: any) {
    //napravi validacija
    let responseValidate = await new TaskService().Validate(Record);
    //responseValidate = JSON.parse(JSON.stringify(responseValidate.data));
    let responsesValidate = [responseValidate];
    let outputValidateOutput = new ValidatorHelper().validateServerResponses(responsesValidate);
    return outputValidateOutput;
  }

  async SaveAsync(Record: any) {
    //napravi validacija
    let response = await new TaskService().Save(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async SearchAsync(Record: any) {
    //napravi validacija    
    let response = await new TaskService().Search(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async NewTaskByTemplateAsync(Record: any) {
    //napravi validacija

    let response = await new TaskService().NewTaskByTemplate(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async SubmitAsync(Record: any) {
    //napravi validacija

    let response = await new TaskService().Submit(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async VerifierAnswerAsync(Record: any) {
    //napravi validacija

    let response = await new TaskService().VerifierAnswer(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async ApproverAnswerAsync(Record: any) {
    //napravi validacija

    let response = await new TaskService().ApproverAnswer(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async UploadDocumentsAsync(Record: any) {
    //napravi validacija

    let response = await new TaskService().UploadDocuments(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


}
